import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PUBLISH_TERMS_ID, SERVICES_SLIDER_ID } from '../../../../constants/nodeIds';
import { useIsMobileDevice, useScrollTo } from '../../../../hooks';
import { TDispatch } from '../../../../redux';
import {
  IAuctionServiceCost,
  closeAuction,
  inputAuctionBet,
  selectPublishTermsService,
} from '../../../../redux/reducers';
import { selectNextLevelServiceBet, selectNextServiceCost } from '../../../../selectors/auction';
import { selectBetPositionErrorCode } from '../../../../selectors/betPosition';
import { selectIsNewOffer } from '../../../../selectors/offer';
import { selectServiceIds } from '../../../../selectors/publishTerms';
import { Slider } from '../../../common/Slider';
import { RaiseServiceLevelButton } from './RaiseServiceLevelButton';
import { trackServiceChange } from './RaiseServiceLevelButton.tracking';
import { getRaiseServiceLevelButtonText } from './utils';

export const RaiseServiceLevelButtonContainer = () => {
  const isMobile = useIsMobileDevice();
  const scrollToPublishTerms = useScrollTo(PUBLISH_TERMS_ID);

  const nextServiceCost = useSelector(selectNextServiceCost);
  const nextLevelServiceBet = useSelector(selectNextLevelServiceBet);
  const errorCode = useSelector(selectBetPositionErrorCode);
  const isNewOffer = useSelector(selectIsNewOffer);
  const serviceIds = useSelector(selectServiceIds);

  const dispatch = useDispatch<TDispatch>();

  const handleClick = React.useCallback(() => {
    // Кнопка не отрендерится, если nextServiceCost отсутствует
    const { serviceId } = nextServiceCost as IAuctionServiceCost;
    const serviceIndex = serviceIds.indexOf(serviceId);

    dispatch(inputAuctionBet(nextLevelServiceBet));

    if (isMobile) {
      dispatch(closeAuction());
    }

    scrollToPublishTerms();

    // Ждем, пока страница доскроллится к карточкам услуг
    setTimeout(() => {
      Slider.scrollToSlide(SERVICES_SLIDER_ID, serviceIndex);

      dispatch(selectPublishTermsService(serviceId));
    }, 500);

    trackServiceChange(serviceId, isNewOffer);
  }, [dispatch, nextLevelServiceBet, nextServiceCost, scrollToPublishTerms, isMobile, isNewOffer, serviceIds]);

  if (!nextServiceCost || errorCode) {
    return null;
  }

  const text = getRaiseServiceLevelButtonText(nextServiceCost.serviceId);

  return <RaiseServiceLevelButton isMobile={isMobile} text={text} onClick={handleClick} />;
};
